import { cx } from '@linaria/core';
import { Chevron } from '@utils/react';
import { wrapper, icon, headingBar, descriptionBar, chevron } from './_card.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function ScrambledCard() {
  return /*#__PURE__*/jsxs("div", {
    className: wrapper,
    children: [/*#__PURE__*/jsxs("svg", {
      className: icon,
      enableBackground: "new 0 0 28 33.1",
      viewBox: "0 0 28 33.1",
      xmlns: "http://www.w3.org/2000/svg",
      children: [/*#__PURE__*/jsx("path", {
        d: "m7 13.5c.3 0 .5-.2.5-.5v-1.7c.3-.1.5-.4.5-.8 0-.6-.4-1-1-1s-1 .4-1 1c0 .4.2.7.5.8v1.7c0 .3.2.5.5.5zm0-3h-.5z"
      }), /*#__PURE__*/jsx("path", {
        d: "m13 8v4.5c0 .3.2.5.5.5s.5-.2.5-.5v-5c0-.3-.2-.5-.5-.5h-1.5v-2c0-2.8-2.2-5-5-5s-5 2.2-5 5v2h-1.5c-.3 0-.5.2-.5.5v10c0 .3.2.5.5.5h1c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-.5v-9zm-10-3c0-2.2 1.8-4 4-4s4 1.8 4 4v2h-8z"
      }), /*#__PURE__*/jsx("path", {
        d: "m27.5 14.7h-23c-.3 0-.5.2-.5.4v17.3c0 .2.2.4.5.4h23c.3 0 .5-.2.5-.4v-17.3c0-.2-.2-.4-.5-.4zm-.5 1v16h-.7l-3.4-6.8c-.4-.7-1.1-1.2-1.9-1.2s-1.5.4-2 1.1l-2.6 4.5c-.8-.9-2.4-2.6-4.4-2.6-2.5 0-4.3 3.8-4.8 5h-2.2v-16zm-1.8 16h-16.9c.7-1.5 2.2-4 3.7-4 2.2 0 4.1 2.8 4.1 2.8.1.1.2.2.4.2s.3-.1.4-.2l3-5.2c.2-.4.6-.6 1.1-.6.4 0 .8.3 1 .7z"
      }), /*#__PURE__*/jsx("path", {
        d: "m10.5 23.7h3c1.7 0 3-1.3 3-3s-1.3-3-3-3c-1.3 0-2.4.8-2.8 2-.5 0-.9.1-1.3.3-.5.4-.9 1-.9 1.7 0 1.1.9 2 2 2zm-.6-2.8c.2-.1.4-.2.6-.2.1 0 .2 0 .4.1.1.1.3 0 .4 0s.2-.2.2-.4c.2-1 1-1.7 2-1.7 1.1 0 2 .9 2 2s-.9 2-2 2h-3c-.6 0-1-.4-1-1 0-.3.2-.6.4-.8z"
      })]
    }), /*#__PURE__*/jsx("span", {
      className: headingBar
    }), /*#__PURE__*/jsx("span", {
      className: descriptionBar
    }), /*#__PURE__*/jsx("span", {
      className: cx(descriptionBar, "last")
    }), /*#__PURE__*/jsx("span", {
      className: chevron,
      children: /*#__PURE__*/jsx(Chevron, {
        size: 10,
        lineWidth: 1.5
      })
    })]
  });
}

export { ScrambledCard };
//# sourceMappingURL=_card.js.map
